@if (ad$ | async; as shopAd) {
  <span [xAdClick]="shopAd" [placement]="placement" [taxonId]="taxonId">
    @switch (getMediaType(shopAd)) {
      @case ('image') {
        <x-ad-picture [media]="shopAd.media"></x-ad-picture>
      }

      @case ('video') {
        <x-ad-video [media]="shopAd.media"></x-ad-video>
      }
    }
  </span>
}
